import React, {useState} from 'react';
import {View, Image, Platform, Text} from 'react-native';
import classes from '../../../../styles/globalClasses';
import gs from '../../../../styles/globalStyles';
import IncomeTax from '../../../../../assets/Icons/IncomeTax';
import AshokChakra from '../../../../../assets/Icons/AshokChakra';
import Button from '../../../../sharedComponents/Button/Button';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import {getParameters, truncateFullName} from '@app/utils';
import { Typography } from '@app/sharedComponents/typography/Typography';

interface ConfirmPanDetailsProps {
  verifiedPanData: any;
  onClose: () => void;
  resetPan: () => void;
  confirmPan: () => void;
    resetPanLoader: boolean;
}

const ConfirmPanDetails: React.FC<ConfirmPanDetailsProps> = ({
  verifiedPanData,
  onClose,
  resetPan,
  confirmPan,
    resetPanLoader
}) => {
    const lengthToTruncateName = 28

    let params ;
    if(Platform.OS === 'web'){
        params = getParameters(window?.location?.href)
    }

    const [firstPart, secondPart] = truncateFullName(verifiedPanData?.fullName, lengthToTruncateName);


    const isDarkMode = params?.isDarkMode
  return (
    <>
      <View style={[gs.setPadding(16), gs.setMarginTop(8)]}>
        <View style={{marginBottom:16}}>
        <Typography 
            typeDLS={TypographyTypeDLS.H2B}
            label="Confirm PAN details"
            textAlign={TextAlignTokens.center}
            color={isDarkMode ?ColorTokens.White :  ColorTokens.Grey_Night}
        />
        </View>
        <View
          style={{
            height: 194,
            borderRadius: 10,
            borderWidth: 1,
            borderColor: '#ACD8F6',
            padding: 20,
            width: '100%',
            backgroundColor: '#D7EFFF',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}>
          <View style={[gs.flexRow, gs.spaceBetween]}>
            <IncomeTax />
            <AshokChakra />
            <Image
              source={{
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bharat_india.png',
              }}
              style={{ width: 79, height: 31 }}
            />
          </View>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              position: 'absolute',
              bottom: 20,
              width: Platform.OS !== 'web' ? '100%' : '92%',
              ...(Platform.OS !== 'web' && {
                right: 0,
                marginRight: 16,
              }),
            }}>
            <View>
              <Typography
                    label={firstPart}
                    fontWeight={"700"}
                    fontSize={FontSizeTokens.XL}
                    lineHeight={24}
                    color={ColorTokens.Grey_Night}
                    fontFamily={FontFamilyTokens.Poppins}
                />
                {Boolean(secondPart) &&
                    <Typography
                        label={secondPart}
                        fontWeight={"700"}
                        fontSize={FontSizeTokens.XL}
                        lineHeight={24}
                        color={ColorTokens.Grey_Night}
                        fontFamily={FontFamilyTokens.Poppins}
                    />
                }
                <Typography
                    label={verifiedPanData?.panNumber}
                    fontWeight={"400"}
                    fontSize={FontSizeTokens.XL}
                    lineHeight={24}
                    color={ColorTokens.Grey_Charcoal}
                    fontFamily={FontFamilyTokens.Inter}
                />
            </View>
            <Image
              source={{
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pan_placeHolder.png',
              }}
              style={{ width: 48, height: 48 }}
            />
          </View>
        </View>
        <View style={[gs.setMarginTop(24)]}>
          <Button
            size={'MD'}
            eventName='KYC_PAN_VERIFICATION_SHEET_CONTINUE'
            label={'Yes, I confirm'}
            type={'SOLID'}
            handlePress={confirmPan}
          />
        </View>
        <View style={[gs.setMarginTop(12)]}>
          <Button
            size={'MD'}
            eventName='KYC_PAN_VERIFICATION_SHEET_EDIT'
            label={'Edit PAN details'}
            type={'OUTLINED'}
            disabled={resetPanLoader}
            handlePress={resetPan}
            buttonLoader={resetPanLoader}
          />
        </View>
      </View>
    </>
  );
};
export default ConfirmPanDetails;
